export function getInitialStateArt() {
   return {
      artCompanies: [],
      artEstados: [],
   };
}

export default getInitialStateArt();
